import * as React from "react";
import {Box, Container, IconButton, Stack, Typography} from "@mui/material";
import MailIcon from "@mui/icons-material/Mail";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import {Link} from "react-router-dom";
import logo from "../logo/logo512.png";
import {CONTACT_MAIL, FACEBOOK, INSTAGRAM} from "../config";
import {colors} from "../styling/GlobalTheme";

/* Pied de page (remplace l'ancienne barre du bas) */
export default function SimpleBottomNavigation() {
    const linkSx = {color: "#aab4c5", textDecoration: "none", "&:hover": {color: colors.glacier}};
    return (
        <Box component="footer" sx={{bgcolor: "#070c16", color: "#aab4c5", pt: 7, pb: 4}}>
            <Container maxWidth="lg">
                <Box sx={{display: "grid", gridTemplateColumns: {xs: "1fr", md: "2fr 1fr 1fr"}, gap: 4}}>
                    <Box>
                        <img src={logo} alt="Mouch'Paba" style={{height: 56}}/>
                        <Typography sx={{mt: 1.5, maxWidth: 380, fontSize: ".95rem"}}>
                            Mouch'Paba Telemark Club – le télémark en Valais, de l'initiation à la Coupe du monde.
                        </Typography>
                    </Box>
                    <Stack spacing={1}>
                        <Typography sx={{color: "#fff", fontWeight: 700}}>Le site</Typography>
                        <Box component={Link} to="/course" sx={linkSx}>Course FIS &amp; Children</Box>
                        <Box component={Link} to="/activites" sx={linkSx}>Activités</Box>
                        <Box component={Link} to="/club" sx={linkSx}>Le club</Box>
                        <Box component={Link} to="/mouchtec" sx={linkSx}>Mouch'Tec</Box>
                        <Box component={Link} to="/impressum" sx={linkSx}>Impressum</Box>
                    </Stack>
                    <Stack spacing={1}>
                        <Typography sx={{color: "#fff", fontWeight: 700}}>Contact</Typography>
                        <Box component="a" href={`mailto:${CONTACT_MAIL}`} sx={linkSx}>{CONTACT_MAIL}</Box>
                        <Stack direction="row" spacing={1} sx={{ml: -1}}>
                            <IconButton href={`mailto:${CONTACT_MAIL}`} aria-label="E-mail" sx={{color: "#fff"}}><MailIcon/></IconButton>
                            <IconButton href={INSTAGRAM} target="_blank" rel="noopener" aria-label="Instagram" sx={{color: "#fff"}}><InstagramIcon/></IconButton>
                            <IconButton href={FACEBOOK} target="_blank" rel="noopener" aria-label="Facebook" sx={{color: "#fff"}}><FacebookIcon/></IconButton>
                        </Stack>
                    </Stack>
                </Box>
                <Typography sx={{mt: 5, pt: 3, borderTop: "1px solid #1c263a", fontSize: ".85rem", textAlign: "center"}}>
                    © {new Date().getFullYear()} Mouch'Paba Telemark Club
                </Typography>
            </Container>
        </Box>
    );
}
